@if (loading$ | async) {
  <div class="fixed top-0 left-0 w-screen h-screen bg-white/70 z-[9999] flex items-center justify-center">
    <div class="flex items-center justify-center">
      <mat-progress-spinner
        mode="indeterminate"
        color="primary"
        diameter="50">
      </mat-progress-spinner>
    </div>
  </div>
}
